import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import moment from "moment";
import { getField } from "@joandvgv/vuex-map-fields";
import { denormalize } from "normalizr";
import { emailSchema } from "./marketing-schema";
export const GET_MARKETING_EMAILS = "GET_MARKETING_EMAILS";
export const CAMPAIGNS = "CAMPAIGNS";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const LISTS = "LISTS";
export const SEGMENTS = "SEGMENTS";
export const GET_CAMPAIGN_STATISTICS = "GET_CAMPAIGN_STATISTICS";
export const GET_SEGMENTS_TRANSLATION_MAP = "GET_SEGMENTS_TRANSLATION_MAP";
const getters = {
  [GET_MARKETING_EMAILS]: state => {
    const {
      allIds,
      byId
    } = state.marketingEmails;
    return denormalize(allIds, [emailSchema], {
      emails: byId
    });
  },
  [CAMPAIGNS]: state => {
    var _context, _context2, _state$campaigns$byId;
    return _sortInstanceProperty(_context = _filterInstanceProperty(_context2 = _Object$values((_state$campaigns$byId = state.campaigns.byId) != null ? _state$campaigns$byId : {})).call(_context2, ({
      campaignId
    }) => campaignId !== "add")).call(_context, function (a, b) {
      const dateA = a.status === "cancelled" ? a.updatedAt : a.lastSendDate || a.scheduledDate;
      const dateB = b.status === "cancelled" ? b.updatedAt : b.lastSendDate || b.scheduledDate;
      return moment(dateB).local().valueOf() - moment(dateA).local().valueOf();
    });
  },
  [GET_CAMPAIGN]: state => campaignId => {
    return state.campaigns.byId[campaignId];
  },
  [LISTS]: state => {
    var _state$lists$byId;
    return _Object$values((_state$lists$byId = state.lists.byId) != null ? _state$lists$byId : {});
  },
  [SEGMENTS]: state => {
    return state.segments;
  },
  [GET_CAMPAIGN_STATISTICS]: state => campaignId => {
    return state.campaigns.byId[campaignId].statistics;
  },
  [GET_SEGMENTS_TRANSLATION_MAP]: state => name => {
    return state.segmentsTranslationMap[name];
  },
  getField
};
export default getters;